module.exports = {
  messages: {
    CRATE_LEBENSLAUF_TEMPLATES_COVER_LETTER_AI_BANNER:
      'This is a draft text generated by AI. Please review it and make it your own.',
    CRATE_LEBENSLAUF_TEMPLATES_COVER_LETTER_AI_FEEDBACK: 'Helpful?',
    CRATE_VITA_PREVIEW_PAGINATION_LEFT: 'Previous page',
    CRATE_VITA_PREVIEW_PAGINATION_RIGHT: 'Next page',
    CRATE_VITA_PREVIEW_PRESENT: 'Present',
    CRATE_VITA_TEMPLATE_COVER_LETTER_TAG: 'Cover letter',
    CRATE_VITA_TEMPLATE_TAG: 'CV',
    CRATE_VITA_TEMPLATES_ABOUT_ME_TITLE: 'About me',
    CRATE_VITA_TEMPLATES_EDUCATION_TITLE: 'Educational background',
    CRATE_VITA_TEMPLATES_LABEL_ADDRESS: 'Address',
    CRATE_VITA_TEMPLATES_LABEL_BIRTH: 'DOB',
    CRATE_VITA_TEMPLATES_LABEL_COUNTRY: 'Country',
    CRATE_VITA_TEMPLATES_LABEL_EMAIL: 'E-mail',
    CRATE_VITA_TEMPLATES_LABEL_PHONE: 'Phone',
    CRATE_VITA_TEMPLATES_PERSONAL_TITLE: 'Personal details',
    CRATE_VITA_TEMPLATES_PROFESSIONAL_TITLE: 'Professional experience',
    CRATE_VITA_TEMPLATES_SKILLS_TITLE: 'Skills',
  },
};
